import type { JSX } from "react";
import type { DeviceProfile } from "../types";
import { formatNumber } from "./format";
import { SectionTable } from "./SectionTable";

export const CategoriesSegmentsPanel = ({
  profile,
}: {
  profile: DeviceProfile;
}): JSX.Element => (
  <div className="space-y-4">
    <div>
      <h4 className="mb-2 text-sm font-semibold uppercase text-(--text-secondary)">
        Categories served
      </h4>
      <SectionTable
        headers={["Category", "Count"]}
        rows={profile.categoriesServed.map((row) => [
          row.category,
          formatNumber(row.count),
        ])}
        emptyLabel="No categories recorded."
      />
    </div>
    <div>
      <h4 className="mb-2 text-sm font-semibold uppercase text-(--text-secondary)">
        Segments targeted
      </h4>
      <SectionTable
        headers={["Segment", "ID", "Count"]}
        rows={profile.segments.map((row) => [
          row.name ?? "Unnamed",
          row.segmentId,
          formatNumber(row.count),
        ])}
        emptyLabel="No segments served."
      />
    </div>
  </div>
);
